import { useQuery } from '@tanstack/react-query';
import { fetchCurrencyList } from '../data-provider/currency-list';

export const useGetCurrencyList = () => {
  return useQuery({
    queryKey: ['currency-list'],
    queryFn: () => fetchCurrencyList(),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
